var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"um-slider-wrapper"},[_c('vue-slider',_vm._b({ref:"slider",attrs:{"value":_vm.currentValue},on:{"callback":function($event){return _vm.onChange(_vm.currentValue)},"drag-end":function($event){return _vm.afterChange(_vm.currentValue)}}},'vue-slider',_vm.options,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8af1764c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/range/range.vue
// module id = null
// module chunks = 